import React, { useEffect, useRef, useState } from 'react'
import constants from '../constants'
import { gsap } from 'gsap'

const Footer = () => {
  const contentEl = useRef()
  const iconEl = useRef()
  const tl = useRef()
  const [isOpen, setIsOpen] = useState(false)
  useEffect(() => {
    tl.current = gsap.timeline()
    tl.current.fromTo(contentEl.current, { height: `0` }, { height: `auto`, duration: 0.4, ease: `expo.inout` }, 0)
    tl.current.set(iconEl.current, { rotate: `-180deg` }, 0)
    tl.current.pause(0)
  }, [])
  const onClick = () => {
    setIsOpen(!isOpen)
    if (isOpen) {
      tl.current.reverse()
    } else {
      tl.current.play(0)
    }
  }
  const year = new Date().getFullYear()
  return (
    <div>
      <div className={`tw-w-full tw-bg-gray-light tw-pt-12 lg:tw-pt-24 tw-pb-12 lg:tw-pb-48`}>
        <div className={`tw-w-full tw-px-6 lg:tw-px-0 lg:tw-w-7/12 tw-mx-auto`}>
          <div className={`tw-relative tw-z-20 tw-font-sans`}>
            <div className={`block-date tw-whitespace-nowrap`} style={{ fontSize: `22.2vw`, lineHeight: `16vw`, color: `transparent`, WebkitTextStroke: `1px`,  WebkitTextStrokeColor: `#767676` }}>{year}</div>
            <h2 className={`${constants.h1} tw-w-10/12 tw-mx-auto tw-relative tw-top-0 tw-my-8 lg:tw-my-0 lg:tw--top-8 tw-uppercase tw-z-50 section-title-h2 tw-text-red`}>
              <div></div>
              <div>{constants.UI.history}</div>
            </h2>
            <div className={`block-date tw-whitespace-nowrap`} style={{ fontSize: `22.2vw`, lineHeight: `0`, color: `transparent`, WebkitTextStroke: `1px`,  WebkitTextStrokeColor: `#767676` }}>
              &middot;&middot;&middot;
            </div>
          </div>
        </div>
      </div>
      <div className={`tw-py-12 lg:tw-py-24 tw-border-t tw-border-b tw-border-gray`}>
        <div className={`tw-w-full tw-px-6 lg:tw-px-0 lg:tw-w-8/12 tw-mx-auto`}>
          <button style={{ outline: 0 }} onClick={onClick} className={`tw-flex tw-justify-between tw-items-center tw-h-full tw-w-full tw-py-6 tw-pl-12 lg:tw-pl-0`}>
            <div className={`tw-flex tw-relative tw--left-14 tw-w-1/2`}>
              <div style={{ height: `1px`, top: `5px` }} className={`tw-w-10 tw-bg-gold tw-relative`}/>
              <h3 className={`${constants.h5} tw-text-left tw-font-regular tw-uppercase tw-text-gray-600 tw-pl-4`}>{constants.UI.creditstitle}</h3>
            </div>
            <div className={`tw-pl-4 tw-pr-1 tw-py-1 lg:tw-pl-12 lg:tw-pr-1 lg:tw-py-1 tw-w-2/12 lg:tw-w-1/12`}>
              <svg ref={iconEl} className={``} viewBox="0 0 19.8 11.3">
                <polygon points="18.4,11.3 9.9,2.8 1.4,11.3 0,9.9 9.9,0 19.8,9.9" fill={`#767676`}/>
              </svg>
            </div>
          </button>
          <div ref={contentEl} className={`tw-overflow-hidden`}>
            <p className={`${constants.paragraph}`}>{constants.UI.credits}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
